import HapticsButtonWrapper from "@Components/generic/haptics-button-wrapper";
import { Tab, TabProps, useTheme } from "@mui/material";
import { forwardRef } from "react";

interface IHeaderTab {
  label: string;
  index: number;
}

const HeaderTab = forwardRef<HTMLDivElement, TabProps & IHeaderTab>((props, ref) => {
  const theme = useTheme();
  const { index, ...rest } = props;
  return (
    <HapticsButtonWrapper>
      <Tab
        ref={ref}
        id={`simple-tab-${index}`}
        aria-controls={`simple-tabpanel-${index}`}
        {...rest}
        sx={{
          zIndex: 1,
          textTransform: "capitalize",
          padding: theme.spacing(0.5, 2),
          color: "dsNeutral.v300",
          minHeight: 0,
          "&.Mui-selected": {
            color: "common.black",
          },
          ...theme.typography.textS500,
        }}
        disableRipple
      />
    </HapticsButtonWrapper>
  );
});

HeaderTab.displayName = "HeaderTab";

export default HeaderTab;
